import { Injectable } from '@angular/core';

import { MedispanService } from '../../services/medispan/medispan.service';
import { PharmacyLocatorService } from '../../services/pharmacy-locator/pharmacy-locator.service';

import { PharmacyLookupServiceInterface } from '../../widgets/pharmacy-lookup/pharmacy-lookup-service-interface.service';
import { DrugLookupServiceInterface } from '../../widgets/drug-lookup/drug-lookup-service-interface.service';
import { LocatorServiceInterface } from '../../widgets/locator/locator-service-interface.service';
import { MapServiceInterface } from '../../widgets/map/map-service-interface.service';

@Injectable()
export class PharmacyLocatorGateway {
  constructor(
    private medispanService: MedispanService,
    private pharmacyLocatorService: PharmacyLocatorService,
    private locatorServiceInterface: LocatorServiceInterface,
    private drugLookupServiceInterface: DrugLookupServiceInterface,
    private pharmacyLookupServiceInterface: PharmacyLookupServiceInterface,
    private mapServiceInterface: MapServiceInterface) {
  };

  initialize() {
      this.locatorServiceInterface.getLocationByAddress = (searchAddress) => {

          var returnThis = this.pharmacyLocatorService.getAddress(searchAddress, '');
          return returnThis;
      //return this.pharmacyLocatorService.getAddress(searchAddress, '');
    };

    this.drugLookupServiceInterface.getDrug = (drugName) => {
      return this.medispanService.getDrug(drugName);
    };

    this.drugLookupServiceInterface.getDrugByNDC = (ndc) => {
      return this.medispanService.getDrugByNDC(ndc);
    };

    this.pharmacyLookupServiceInterface.getBySquare = (square) => {
      return this.pharmacyLocatorService.getPharmacyBySquare(square);
    };
  }
}




// WEBPACK FOOTER //
// D:/a/29/s/PDMI.PharmacyLocator.Web/src/lib/services/pharmacy-locator-gateway.ts